import VModal from 'vue-js-modal'

export default (Vue) => {
  Vue.use(VModal, { dialog: true, dynamic: true, injectModalsContainer: true })
}
